import { ToastMessageType, useShowToast } from '~/composables/useShowToast';
import { buildAuthLoginUri } from '~/utils/buildAuthLoginUri';

const SESSION_EXPIRY_NOTICE_KEY = 'auth.sessionExpired.message';
const SESSION_EXPIRY_FALLBACK =
  'Your session has expired. Please <a href="{loginUrl}">sign in again</a>.';
const NOTICE_DEBOUNCE_MS = 10_000;

/**
 * Shows a debounced, non-blocking warning when background auth refresh fails.
 * Re-login is left to existing header/login affordances (return URL preserved).
 */
export function useSessionExpiryNotice() {
  const lastShownAt = useState<number>(
    'session-expiry-notice-last-shown',
    () => 0
  );
  const { $textDictionary } = useNuxtApp();
  const { showToast } = useShowToast();
  const route = useRoute();

  function notifySessionExpired(): void {
    const now = Date.now();
    if (now - lastShownAt.value < NOTICE_DEBOUNCE_MS) {
      return;
    }
    lastShownAt.value = now;

    const loginUrl = buildAuthLoginUri(route.path, route.query, 'login', false);
    const template =
      $textDictionary.value[SESSION_EXPIRY_NOTICE_KEY] ??
      SESSION_EXPIRY_FALLBACK;
    const message = template.replace('{loginUrl}', loginUrl);

    showToast(message, {
      severity: ToastMessageType.WARNING,
      life: 8_000
    });
  }

  return { notifySessionExpired };
}
